import React from 'react'
import {
  getEpochAdjustedTime,
  padTime,
  weekArray,
  monthArray,
  weekMonthReducer
} from 'AccountsUtils'
import PropTypes from 'prop-types'
import { TERMINAL_LABEL } from 'AccountsConstants/language/trips'
import { getMappedValue } from '../utils/arabicUtils'

const airDataExtractor = (data, keyMapper) => {
  let date = data[`${keyMapper}Date`]
  const offset = data[`${keyMapper}AirportTimeZone`]
  date =
    date && getEpochAdjustedTime(date, offset)
      ? getEpochAdjustedTime(date, offset)
      : null
  const header = `${data[`${keyMapper}Airport`]}`
  const headerHighlight = date
    ? `${padTime(date.getHours())}:${padTime(date.getMinutes())}`
    : null
  const highlight = data[`${keyMapper}Terminal`]
    ? data[`${keyMapper}Terminal`]
    : null
  const subHeader = `${data[`${keyMapper}AirportName`]}`
  const dateTime = weekMonthReducer(date, false)
  return { header, highlight, subHeader, dateTime, headerHighlight }
}
const hotelDataExtractor = (data, keyMapper) => {
  let date = data[`${keyMapper}Date`]
  const { label } = data
  date = date && getEpochAdjustedTime(date) ? getEpochAdjustedTime(date) : null
  const header = date ? `${monthArray[date.getMonth()]}` : null
  const headerHighlight = date ? `${padTime(date.getDate())}` : null
  const highlight = null
  const subHeader = null
  const dateTime = `${weekArray[date.getDay()]}, ${
    date.getHours() > 12 ? date.getHours() - 12 : padTime(date.getHours())
  } ${date.getHours() > 12 ? 'PM' : 'AM'}`
  return { header, highlight, subHeader, dateTime, headerHighlight, label }
}
const verticalMap = { air: airDataExtractor, hotel: hotelDataExtractor }
const verticalMapper = (vertical, data, keyMapper) => {
  let returnValue = null
  if (vertical) {
    returnValue = verticalMap[vertical](data, keyMapper)
  }
  return returnValue
}
const terminalAppender = str =>
  str && str.toLowerCase().indexOf('terminal') === -1
    ? `${getMappedValue(TERMINAL_LABEL)} ${str}, `
    : `${str}, `
const DateTime = ({
  data,
  vertical,
  keyMapper,
  invert = false,
  isPWA = true
}) => {
  const {
    label,
    header,
    dateTime,
    subHeader,
    highlight,
    headerHighlight
  } = verticalMapper(vertical, data, keyMapper)
  return (
    <div
      className={`flex flex-column max-33 ${invert ? 'flex-top' : 'pr-2'} ${
        !invert && isPWA ? 'flex-bottom' : ''
      }
      ${invert && !isPWA ? 'pl-6' : 'pl-2'}
      `}
    >
      <If condition={label}>
        <p className="fs-11 color-8a tt-uppercase">{label}</p>
      </If>
      <If condition={header}>
        <div
          className={`flex tt-uppercase ${
            invert ? 'flex-row-reverse flex-end' : ''
          } fs-20 ${isPWA ? '' : 'pb-2'}`}
        >
          <h1>{header}</h1>
          <If condition={headerHighlight}>
            <span className={`${invert ? 'pr-1 pl-1' : 'pl-1 pr-1'} fw-700`}>
              {headerHighlight}
            </span>
          </If>
        </div>
      </If>
      <If condition={dateTime}>
        <p className={`pwa-sub-title ${isPWA ? 'py-1' : 'pb-1 fs-body'} `}>
          {dateTime &&
            (() => {
              const [dayOfWeek, rest] = dateTime.split(', ')
              const [date, month] = rest.split(' ')

              return `${getMappedValue(dayOfWeek)}, ${date} ${getMappedValue(
                month
              )}`
            })()}
        </p>
      </If>
      <If condition={subHeader}>
        <p
          className={`${isPWA ? 'fs-11' : 'fs-caption-2'} color-8a 
            ${!invert && !isPWA && 'ta-left'}
            ${invert && !isPWA && 'ta-left'}
            ${!invert && isPWA && 'ta-right'}
            ${invert && isPWA && 'ta-left'}
            `}
        >
          <If condition={highlight}>
            <span className="fw-600 color-black">
              {terminalAppender(highlight)}
            </span>
          </If>
          {subHeader}
        </p>
      </If>
    </div>
  )
}
DateTime.defaultProps = {
  data: {},
  keyMapper: ''
}
DateTime.propTypes = {
  keyMapper: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.object),
  vertical: PropTypes.string.isRequired
}
export default DateTime
